<template>

  <div id="app">

  </div>

</template>

<script>
export default {
  name: "App",
  computed: {
    isHome() {
      return this.$route.path === "/";
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },

};
</script>

<style scoped>

#site-header {
  font-size: 1.6rem;
  font-weight: bold;
  text-decoration: none;
  color: inherit;
}

#page-header {
  /*background-color: yellow;*/
  font-size: 1.2rem;
  font-weight: bold;
  padding: 10px 20px;
}

#back-icon {
  width: 21px;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  padding-right: 20px;
}

/* Remove the float: left since we're using flexbox now */
#back-icon:hover {
  transform: scale(1.1);
}

</style>